import { SalaryStatus } from './types';

export const getStatusBadgeVariant = (status: string) => {
  switch (status) {
    case SalaryStatus.ACTIVE:
      return 'success';
    case SalaryStatus.UPCOMING:
      return 'warning';
    case SalaryStatus.EXPIRED:
      return 'secondary';
    default:
      return 'secondary';
  }
};
